import { path } from 'ramda';

import { FEATURE_NAME as $, LIST, FILTERS } from './consts';

export const getRegions = path([$, LIST]);
export const getRegion = (id) => path([$, LIST, id]);
export const getRegionProp = (id) => (name) => path([$, LIST, id, name]);
export const getRegionsFilters = path([$, FILTERS]);
